import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AuthenticationService } from '../auth/authentication.service';
import * as CryptoJS from 'crypto-js';
import { SessionStorageService } from './session-storage.service';
import { environment } from '../../environments/environment';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private service:AuthenticationService, private sessStorage: SessionStorageService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    var azureClientID = environment.billingProps.aud;
    //JSON.parse( localStorage.getItem("BillingPortalProps")??"").AzureClientID;
    const azureToken: any =
    JSON.parse(
      localStorage.getItem(
        JSON.parse(
          localStorage.getItem(
            `msal.token.keys.${azureClientID}`
          ) ?? ""
        ).accessToken[0]
      ) ?? ""
    )?.secret ?? "";
   
    const apigeeToken =  this.sessStorage.getItem<string>("apigeeToken-bp");
    //const apigeeToken =  localStorage.getItem("apigeeToken-bp");
    let parsedToken;
    if (apigeeToken) {
      const ciphertext = CryptoJS.enc.Utf8.stringify(
        CryptoJS.enc.Base64.parse(apigeeToken)
      );
      const apigeePayload = CryptoJS.AES.decrypt(
        ciphertext,
        azureClientID!
      ).toString(CryptoJS.enc.Utf8);
     var tokenData = JSON.parse(apigeePayload);
     parsedToken = tokenData.token;
    }
            
    if (azureToken) {

      var headers = request.headers;
      
      var headers = request.headers;
      let isLocal = window.location.href.includes("localhost") || window.location.href.includes("127.0.0.1");
      let isTokenReq = request.url.includes("/apigee/v1/token")
      if(!isLocal && environment.enableLog && !isTokenReq) {
        try {
          let logTraceValue = headers.get('X-Log-Trace') || "{}";
          let logTraceJSON = JSON.parse(logTraceValue);
          logTraceJSON.sessionId = environment.billingProps.sessionId
          logTraceJSON.userEmail = environment.billingProps.userEmail
          logTraceJSON.env = environment.env
          let base64EncodedTrace = window.btoa(JSON.stringify(logTraceJSON))
          headers = headers.set('X-Log-Trace', base64EncodedTrace)
          headers = headers.set('X-CABA-API-Key', "b0a78cfa-5f9e-4d8f-bd7a-68ca213f0bed")
        } catch (error) {
          console.log("Could not send proper log trace", error)
        }
      }
      else headers = headers.delete('X-Log-Trace')
       headers =  headers.set('azuretoken', `${azureToken}`);
       if(parsedToken)
          headers =  headers.set('Authorization', `Bearer ${parsedToken}`);
      const cloned = request.clone({
          headers: headers,
      });
      return next.handle(cloned).pipe(
        catchError( (error: HttpErrorResponse) => { 
           let errMsg = '';
           // Client Side Error
           console.log(error)
           if (error.error instanceof ErrorEvent) {    
             errMsg = `Error: ${error.error.message}`;
           } 
           else if (error.error instanceof ArrayBuffer) {
             if (("TextDecoder" in window)) {
              try {
                const decoder = new TextDecoder()
                let errorStr = decoder.decode(error.error)
                let errorJson = JSON.parse(errorStr)
                errMsg = errorJson.message                
              } catch (error) {
                console.log(error)                
              }
             }
           }
           else {  // Server Side Error
            if(error.error){
              errMsg = `${error.error.message}`;
            }else{
              errMsg = `${error.message}`;
            }
           }
           console.log(errMsg)
           return throwError(errMsg);
         })
      );
    } else {
      return next.handle(request).pipe(
        catchError( (error: HttpErrorResponse) => { 
           let errMsg = '';
           // Client Side Error
           if (error.error instanceof ErrorEvent) {        
             errMsg = `Error: ${error.error.message}`;
           } 
           else {  // Server Side Error
             errMsg =  `${error.error.message}`;
           }
           console.log(error)
           return throwError(errMsg);
         })
      );;
    }
  }
}
